import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { SharedInfoService } from '../../shared/services/shared-info/shared-info.service';
import { ThesisComponent, ThesisType } from '../thesis/thesis.component';

@Component({
  selector: 'rcc-pdf-custom-results',
  standalone: true,
  imports: [CommonModule, ThesisComponent],
  templateUrl: './rcc-pdf-custom-results.html',
  styleUrl: './rcc-pdf-custom-results.scss',
})
export class RccPdfCustomResultsComponent {
  @Input() printClientName = '';
  @Input() chartImageDataUrl: string | null = '';
  // data needed to supply thesis component
  @Input() currentThesisType: ThesisType = 'profitable';
  @Input() rothConversionTaxAmount: string = '';
  @Input() yearsUntilDist: number = 0;
  @Input() assetDifference: string = '';
  @Input() betrValue: string = '';
  @Input() paymentMethod: string = '';
  // controls showing / hiding profitability point content
  @Input() hasProfitabilityPoint: boolean | undefined = false;

  pdfReportContent = content.Data.v4_rcc_root.content.pdfreport;
  desirableProfitabilityPointContent = content.Data.v4_rcc_root.content.desirableProfitabilityPoint;
  calculatorResultsContent = content.Data.v4_rcc_root.content.calculatorResults;

  constructor(
    private readonly contentService: ContentService,
    public readonly clientInfo: SharedInfoService,
  ) {
    this.contentService.getContent().subscribe((data) => {
      this.pdfReportContent = data.Data.v4_rcc_root.content.pdfreport;
      this.desirableProfitabilityPointContent =
        data.Data.v4_rcc_root.content.desirableProfitabilityPoint;
      this.calculatorResultsContent = data.Data.v4_rcc_root.content.calculatorResults;
    });
  }

  get printDate(): string {
    return new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
}
